import { z } from 'zod';

export const requestedAppUpdateSchema = z.object({
  id: z.string().optional(),
  latestRequestNumber: z.number().nullish(),
});

export type TRequestedAppUpdateSchema = z.infer<
  typeof requestedAppUpdateSchema
>;
